<template>
    <div class="main">
        <FormWrapper
            ref="the_form"
            :action="route('admin.events.enrollments.attendance', routeParam)"
            method="POST"
        >
            <input v-if="close" type="hidden" name="close" value="1"/>
            <div class="title-bar pt-3">
                <a
                    class="btn btn-info float-right ml-2"
                    :href="route('admin.events.enrollments.index', routeParam)"
                >Back to Roster</a
                >
                <a
                    v-if="!isClosed"
                    class="btn btn-warning float-right ml-2"
                    href="#"
                    @click.prevent="saveAndClose()"
                >Save & Close Event</a
                >
                <button type="submit" class="btn btn-success float-right ml-2">
                    Save Changes
                </button>
                <h1 class="mb-1">Event Roster</h1>
                <h4 class="text-primary mb-3">{{ title }}</h4>
            </div>

            <div class="content py-3 px-5">
                <div class="row">
                    <div class="col-12">
                        <transition name="fade">
                            <Alert v-if="hasAlert" :alert="alert"/>
                        </transition>

                        <div class="row">
                            <div class="col-12 mb-2">
                                <a
                                    class="btn-sm btn-info float-right"
                                    href="#"
                                    @click.prevent="resetAll()"
                                >Reset All</a
                                >
                                <a
                                    class="btn-sm btn-danger float-right mr-2"
                                    href="#"
                                    @click.prevent="markAllDidNotAttend()"
                                >Mark All as Did Not Attend</a
                                >
                                <a
                                    class="btn-sm btn-success float-right mr-2"
                                    href="#"
                                    @click.prevent="markAllAttended()"
                                >Mark All as Attended</a
                                >
                            </div>

                            <div class="col-12 mb-3">
                                <ListTable
                                    :items="items"
                                    :columns="columns"
                                    :activeColumns="activeColumns"
                                    :hideNoResults="true"
                                    :hasDetailsPane="false"
                                    :swappableColumns="false"
                                    @sort-by="setSort"
                                >
                                    <template v-slot:col_attendance="{ item }">
                                        <input
                                            type="hidden"
                                            :name="`attendance[${item.id}][enrollment_id]`"
                                            :value="item.id"
                                        />
                                        <Field
                                            type="select"
                                            :name="`attendance[${item.id}][status]`"
                                            :value="item.attendance_status"
                                            :options="statusOptions"
                                        />
                                    </template>
                                </ListTable>
                            </div>

                            <div class="col-12 d-flex justify-content-between">
                                <div>
                                    <button type="submit" class="btn btn-success">
                                        Save Changes
                                    </button>
                                    <a
                                        v-if="!isClosed"
                                        class="btn btn-warning ml-2"
                                        href="#"
                                        @click.prevent="saveAndClose()"
                                    >
                                        Save & Close Event
                                    </a>
                                    <a
                                        class="btn btn-info ml-2"
                                        :href="route('admin.events.enrollments.index', routeParam)"
                                    >
                                        Back to Roster
                                    </a>
                                </div>
                                <div>
                                    <a
                                        v-if="event.roster_uploaded_at"
                                        class="btn btn-success"
                                        :href="route('training.events.roster.download', routeParam)"
                                    >
                                        <span class="icon icon-download"></span>
                                        <span class="text">View Uploaded Roster</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FormWrapper>
    </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListTable from "components/listings/Table"

export default {
    components: {
        ListTable,
    },

    mixins: [DisplaysAlerts],

    props: {
        event: {type: Object, required: true},
        enrollments: {type: Array, default: () => []},
    },

    data() {
        return {
            items: [],
            close: false,
        };
    },

    computed: {
        routeParam() {
            return {event: this.event.id};
        },

        title() {
            return (
                `${this.event.name} - ` +
                this.$moment(this.event.start_date).format("MM/DD/YYYY") +
                ` (ID: ${this.event.id})`
            );
        },

        isClosed() {
            return this.event.status === this.$root.constants.CLOSED_EVENT;
        },

        statusOptions() {
            return [
                {
                    label: "Attended",
                    value: this.$root.constants.ATTENDANCE_ATTENDED,
                },
                {
                    label: "Did not attend",
                    value: this.$root.constants.ATTENDANCE_NOT_ATTENDED,
                },
            ];
        },

        columns() {
            return [
                { key: 'user.name', label: 'Name', sortable: true },
                { key: 'user.hvac_id', label: 'HVAC ID', sortable: true },
                { key: 'user.company.name', label: 'Company Name', sortable: true },
                { key: 'user.company.hvac_id', label: 'Company HVAC ID', sortable: true },
                { key: 'brand.name', label: 'Brand', sortable: true },
                { key: 'attendance', label: 'Attendance', sortable: false },
            ]
        },

        activeColumns() {
            return this.columns.map(c => c.key);
        }
    },
    methods: {
        markAll(status) {
            var items = _.cloneDeep(this.items);
            this.items = [];
            items.forEach((item) => {
                item.attendance_status = status;
            });
            this.items = items;
        },

        markAllAttended() {
            this.markAll(this.$root.constants.ATTENDANCE_ATTENDED);
        },

        markAllDidNotAttend() {
            this.markAll(this.$root.constants.ATTENDANCE_NOT_ATTENDED);
        },

        resetAll() {
            this.markAll(null);
        },

        saveAndClose() {
            this.close = true;
            this.$nextTick(() => {
                this.$refs.the_form.submit();
            });
        },

        setSort(column, direction) {
            this.items = _.orderBy(_.cloneDeep(this.items), [item => {
                // we are sorting users by last name explicitly,
                // not by the full name
                const value = column.key === 'user.name'
                    ? item.user.last_name
                    : _.get(item, column.key);

                if (['user.hvac_id', 'user.company.hvac_id'].indexOf(column.key) > -1) {
                    return value ? parseInt(value) : 0;
                }

                return value ? value.toLowerCase() : '';
            }], direction);
        },
    },
    created() {
        this.items = _.cloneDeep(this.enrollments);
    },
};
</script>